import { Stack } from "@mui/material";
import { useAtom } from "jotai";
import type { FC } from "react";
import {
	TimelineHorizonEnum,
	UpcomingTimelineItemTypeFilterEnum,
} from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { timelineFilterAtom } from "web_myplann/NotificationCenter/Atoms/timelineFilterAtom";
import { FilterRow } from "web_myplann/NotificationCenter/FilterScreen/FilterRow";
import { FilterSection } from "web_myplann/NotificationCenter/FilterScreen/FilterSection";
import {
	horizonResource,
	typeResource,
} from "web_myplann/NotificationCenter/Utils/filterLabels";

const HORIZON_OPTIONS: TimelineHorizonEnum[] = [
	TimelineHorizonEnum.Month,
	TimelineHorizonEnum.HalfYear,
	TimelineHorizonEnum.Year,
];

const TYPE_OPTIONS: UpcomingTimelineItemTypeFilterEnum[] = [
	UpcomingTimelineItemTypeFilterEnum.All,
	UpcomingTimelineItemTypeFilterEnum.Activities,
	UpcomingTimelineItemTypeFilterEnum.Events,
];

export const UpcomingFilters: FC = () => {
	const { t } = useResource();
	const [filter, setFilter] = useAtom(timelineFilterAtom);

	return (
		<Stack data-testid="notification-center-filter-upcoming">
			<FilterSection
				title={t(Resources.NotificationCenter.FilterScreen.HorizonSectionTitle)}
				testIdPrefix="horizon"
			>
				{HORIZON_OPTIONS.map((option, i) => (
					<FilterRow
						key={option}
						label={t(horizonResource(option))}
						selected={filter.horizon === option}
						onClick={() => setFilter((prev) => ({ ...prev, horizon: option }))}
						isLast={i === HORIZON_OPTIONS.length - 1}
						testId={`notification-center-filter-horizon-${option}`}
					/>
				))}
			</FilterSection>
			<FilterSection
				title={t(Resources.NotificationCenter.FilterScreen.TypeSectionTitle)}
				testIdPrefix="type"
			>
				{TYPE_OPTIONS.map((option, i) => (
					<FilterRow
						key={option}
						label={t(typeResource(option))}
						selected={filter.upcomingType === option}
						onClick={() =>
							setFilter((prev) => ({ ...prev, upcomingType: option }))
						}
						isLast={i === TYPE_OPTIONS.length - 1}
						testId={`notification-center-filter-type-${option}`}
					/>
				))}
			</FilterSection>
		</Stack>
	);
};
